<template>
  <button @click="download" :aria-label="$t('buttons.download')" :title="$t('buttons.download')" id="download-button" class="action">
    <download-icon size="1.5x" class="custom-class"></download-icon>
    <span>{{ $t('buttons.download') }}</span>
  </button>
</template>

<script>

import {mapGetters, mapState} from 'vuex';
import { files as api } from '@/api';
import { DownloadIcon } from 'vue-feather-icons';
import { ROUTES } from '@/router';

export default {
  name: 'download-button',
  components: {
    DownloadIcon
  },
  computed: {
    ...mapState(['req', 'selected', 'handleSharedDrive']),
    ...mapGetters(['isListing', 'selectedCount', 'isSharedDrive', 'isLogged'])
  },
  methods: {
    download: function () {
      if (this.$route.name === ROUTES.DRIVE && this.selectedCount === 0) {
        if (this.$route.hash.length > 9) {
          api.downloadId(this.handleSharedDrive, ibbLink);
        } else {
          api.downloadId(this.req.handle, ibbLink);
        }
        this.$showSuccess(this.$t('transfers.downloadadded'));
        return;
      }

      if (this.isSharedDrive && window.location.hash === '') {
        api.downloadId(this.req.items[this.selected[0]].handle);
        this.$showSuccess(this.$t('transfers.downloadadded'));
        return;
      }

      if ((!this.isListing || this.selected.length === 0) && this.$route.name !== ROUTES.DRIVE) {
        api.downloadId(this.req.handle);
        this.$showSuccess(this.$t('transfers.downloadadded'));
        return;
      }

      if (this.$route.name === ROUTES.DRIVE && this.selectedCount > 0) {
        for (let index of this.selected) {
          api.downloadId(this.req.items[index].handle, ibbLink);
        }
      } else {
        for (let index of this.selected) {
          api.downloadId(this.req.items[index].handle);
        }
      }
      this.$showSuccess(this.$t('transfers.downloadadded'));
      return;
    }
  }
};
</script>
